import { useCallback } from 'react'
import {
  getRevenueRealizationAnalyticsReport,
  type ReportBucketType,
  type RevenueRealizationAnalyticsReportResult,
} from '@services/api/reports/finance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type RevenueRealizationFinanceData =
  RevenueRealizationAnalyticsReportResult

export type UseRevenueRealizationFinanceResult = {
  loading: boolean
  error: string | null
  data: RevenueRealizationFinanceData | null
  bucketLabel: string
}

export function useRevenueRealizationFinance(
  toolbarSelection: Record<string, string>,
): UseRevenueRealizationFinanceResult {
  const getBucketFromData = useCallback(
    (data: RevenueRealizationAnalyticsReportResult): ReportBucketType =>
      data.production.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getRevenueRealizationAnalyticsReport,
    getBucketFromData,
    errorMessage: 'Failed to load revenue realization data',
  })
}
